<template>
  <div
    class="y-nav"
    @click="handleClickNav"
  >
    快捷导航
  </div>
  <el-drawer
    v-model="visible"
    title="快捷导航"
    :size="320"
  >
    <drawer-nav
      :menus="appMenus"
      @call="handleClickNav"
    />
  </el-drawer>
</template>

<script lang="ts" setup>
import shared from '@/micro/shared'
import { computed, ref } from 'vue'
import DrawerNav from '@/layout/AppNavDrawer/DrawerNav.vue'
import type { ResourcesChildrenTree } from '@y/types'

const visible = ref<boolean>(false)
const appMenus = computed(() => {
  const routers = shared.getRouters()
  const navRouters: ResourcesChildrenTree[] = []
  routers?.children &&
    routers.children.forEach(app => {
      if (app.urlPath !== `/${appName.value}`) {
        navRouters.push(app)
      }
    })
  return navRouters
})

const appName = computed(() => shared.getAppName())

const handleClickNav = () => {
  visible.value = !visible.value
}
</script>

<style lang="less" scoped>
.y-nav {
  background: var(--app-color-main);
  color: var(--app-color-white);
  position: absolute;
  right: 0;
  top: 50%;
  text-align: center;
  padding: 3px;
  border-radius: 5px 0 0 5px;
  letter-spacing: 0;
  writing-mode: vertical-lr;
  cursor: pointer;
  z-index: 999;
}
</style>
